(() => {
  let savedResultsScroll = 0;
  let lastVisibleTarget = null;

  const root = () => document.getElementById('SgAiSearchOverlay');
  const body = () => root()?.querySelector('.sg-ai-search__body');

  function moveAssistantToTop(focusQuestion = false) {
    const r = root();
    const b = body();
    if (!r || !b) return;

    b.scrollTop = 0;
    requestAnimationFrame(() => {
      b.scrollTop = 0;
      if (!focusQuestion) return;
      const question = r.querySelector('.sg-ai-search__assistant:not([hidden]) .sg-ai-search__question');
      if (!question) return;
      question.setAttribute('tabindex', '-1');
      try { question.focus({ preventScroll: true }); }
      catch (_) { question.focus(); }
      b.scrollTop = 0;
    });
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const start = target.closest('#SgAiSearchOverlay [data-sg-start-assistant]');
    if (start) {
      const b = body();
      savedResultsScroll = b?.scrollTop || 0;
      lastVisibleTarget = null;
      setTimeout(() => moveAssistantToTop(false), 0);
      setTimeout(() => moveAssistantToTop(true), 80);
      return;
    }

    const back = target.closest('#SgAiSearchOverlay [data-sg-back-results]');
    if (back) {
      lastVisibleTarget = null;
      requestAnimationFrame(() => {
        const b = body();
        if (b) b.scrollTop = savedResultsScroll;
      });
    }
  }, true);

  const observer = new MutationObserver(() => {
    const r = root();
    if (!r?.classList.contains('is-assistant-mode')) return;

    const question = r.querySelector('.sg-ai-search__assistant:not([hidden]) .sg-ai-search__question');
    if (question && question !== lastVisibleTarget) {
      lastVisibleTarget = question;
      moveAssistantToTop(true);
      return;
    }

    const recommendation = r.querySelector('.sg-ai-search__assistant:not([hidden]) .sg-commerce-recommendation');
    if (recommendation && recommendation !== lastVisibleTarget) {
      lastVisibleTarget = recommendation;
      moveAssistantToTop(false);
      return;
    }

    const status = r.querySelector('[data-sg-search-status]:not([hidden])');
    if (status && status !== lastVisibleTarget) {
      lastVisibleTarget = status;
      moveAssistantToTop(false);
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden', 'class']
  });
})();
